import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the mParticle connector, which the integrations directory still links
// to. The page lives at `/workspaces/:workspaceId/integrations/mparticle_out`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/mparticle_out'),
});
